var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "create-account-section" },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("img", {
          staticClass: "create-account-background",
          attrs: {
            loading: "lazy",
            src: require("../../assets/AgentLoginBackground.jpg")
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sign-in-outer-wrapper" },
          [
            _c(
              "el-row",
              { staticClass: "sign-in-inner-wrapper" },
              [
                _c(
                  "el-col",
                  { staticClass: "sign-in-title-wrapper", attrs: { span: 24 } },
                  [
                    _c("span", { staticClass: "sign-in-title" }, [
                      _vm._v("Sign in")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { staticClass: "sign-in-form-wrapper", attrs: { span: 24 } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "background-color": "#ffffff",
                          "border-radius": "0 0 15px 15px",
                          padding: "0 16px 30px 16px"
                        }
                      },
                      [
                        _c(
                          "el-form",
                          { staticClass: "sign-in-form" },
                          [
                            _c(
                              "el-row",
                              { staticStyle: { width: "100%" } },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: { padding: "16px 0" },
                                    attrs: { span: 24 }
                                  },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: { placeholder: "Email Address" },
                                        model: {
                                          value: _vm.email,
                                          callback: function($$v) {
                                            _vm.email = $$v
                                          },
                                          expression: "email"
                                        }
                                      },
                                      [
                                        _c("template", { slot: "prepend" }, [
                                          _c("i", {
                                            staticClass: "el-icon-edit-outline"
                                          })
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { staticStyle: { width: "100%" } },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: { "padding-bottom": "16px" },
                                    attrs: { span: 24 }
                                  },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: {
                                          id: "passwordfield",
                                          placeholder: "Password",
                                          type: _vm.viewPassword
                                            ? "text"
                                            : "password"
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.login($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.password,
                                          callback: function($$v) {
                                            _vm.password = $$v
                                          },
                                          expression: "password"
                                        }
                                      },
                                      [
                                        _c("template", { slot: "prepend" }, [
                                          _c("i", {
                                            staticClass: "el-icon-lock"
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _vm.viewPassword
                                          ? _c("template", { slot: "append" }, [
                                              _c("i", {
                                                staticClass: "el-icon-view",
                                                on: {
                                                  click: function($event) {
                                                    _vm.viewPassword = !_vm.viewPassword
                                                  }
                                                }
                                              })
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.viewPassword
                                          ? _c("template", { slot: "append" }, [
                                              _c("i", [
                                                _c("img", {
                                                  staticClass: "icon-hide",
                                                  attrs: {
                                                    src: require("../../assets/el-icon-hide.svg")
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.viewPassword = !_vm.viewPassword
                                                    }
                                                  }
                                                })
                                              ])
                                            ])
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { staticStyle: { width: "100%" } },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      "padding-bottom": "16px",
                                      display: "flex",
                                      "flex-direction": "column"
                                    },
                                    attrs: { span: 24 }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "btn-primary",
                                        on: { click: _vm.login }
                                      },
                                      [_vm._v("Login")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column"
                            },
                            attrs: { span: 4, offset: 20 }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn-underline",
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    _vm.passwordResetDialogVisible = true
                                  }
                                }
                              },
                              [_vm._v("Forgot password?\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dialog",
                              {
                                staticStyle: { margin: "15% 0" },
                                attrs: {
                                  "before-close": _vm.handleClosePasswordReset,
                                  visible: _vm.passwordResetDialogVisible,
                                  center: "",
                                  width: "90%"
                                },
                                on: {
                                  "update:visible": function($event) {
                                    _vm.passwordResetDialogVisible = $event
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      fontSize: "34px",
                                      color: "#101010",
                                      fontFamily: "Metropolis",
                                      fontStyle: "normal",
                                      fontWeight: "600",
                                      lineHeight: "117.647%",
                                      display: "flex",
                                      justifyContent: "start"
                                    },
                                    attrs: { slot: "title" },
                                    slot: "title"
                                  },
                                  [_vm._v("Forgot password")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "forgotPasswordSpan" },
                                  [
                                    _vm._v(
                                      "Provide your account email address to receive an email to reset\n              your password."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-input",
                                  {
                                    staticClass: "forgotPasswordInput",
                                    attrs: { placeholder: "Email Address" },
                                    model: {
                                      value: _vm.emailOnResetPassword,
                                      callback: function($$v) {
                                        _vm.emailOnResetPassword = $$v
                                      },
                                      expression: "emailOnResetPassword"
                                    }
                                  },
                                  [
                                    _c("template", { slot: "prepend" }, [
                                      _c("i", {
                                        staticClass: "el-icon-edit-outline"
                                      })
                                    ])
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "dialog-footer forgotPasswordInputSpanBtn",
                                    attrs: { slot: "footer" },
                                    slot: "footer"
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "forgotPasswordBtn",
                                        attrs: { type: "primary" },
                                        on: { click: _vm.submit }
                                      },
                                      [_vm._v("Submit")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dialog",
                              {
                                staticStyle: { margin: "15% 0" },
                                attrs: {
                                  "before-close": _vm.handleCloseResetEmailSent,
                                  visible: _vm.resetEmailSentDialogVisible,
                                  center: "",
                                  width: "90%"
                                },
                                on: {
                                  "update:visible": function($event) {
                                    _vm.resetEmailSentDialogVisible = $event
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      fontSize: "34px",
                                      color: "#101010",
                                      fontFamily: "Metropolis",
                                      fontStyle: "normal",
                                      fontWeight: "600",
                                      lineHeight: "117.647%",
                                      display: "flex",
                                      justifyContent: "start"
                                    },
                                    attrs: { slot: "title" },
                                    slot: "title"
                                  },
                                  [_vm._v("Please Check Your Email")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "forgotPasswordSpan" },
                                  [
                                    _vm._v(
                                      "An email with a verification link has been sent to\n                  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "font-weight": "bold" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(this.emailOnResetPassword)
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      ". Please check your junk mail to ensure you receive it."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "dialog-footer forgotPasswordInputSpanBtn",
                                    attrs: { slot: "footer" },
                                    slot: "footer"
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "forgotPasswordBtn",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: _vm.handleCloseResetEmailSent
                                        }
                                      },
                                      [_vm._v("Close")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticClass: "sign-up-outer-wrapper" },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-row",
                              { staticClass: "sign-up-divider-outer-wrapper" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "sign-up-divider-wrapper",
                                    attrs: { span: 11 }
                                  },
                                  [_c("div", { staticClass: "divider-start" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "sign-up-divider-wrapper",
                                    attrs: { span: 2 }
                                  },
                                  [
                                    _c("div", { staticClass: "divider-mid" }, [
                                      _vm._v("OR")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "sign-up-divider-wrapper",
                                    attrs: { span: 11 }
                                  },
                                  [_c("div", { staticClass: "divider-end" })]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-row",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  width: "100%"
                                },
                                attrs: { gutter: 20 }
                              },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      "padding-bottom": "16px",
                                      display: "flex",
                                      "justify-content": "flex-end"
                                    },
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "sign-up-lbl font400" },
                                      [_vm._v("Not signed up?")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      "padding-bottom": "16px",
                                      display: "flex",
                                      "justify-items": "flex-start"
                                    },
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "btn-underline",
                                        attrs: { type: "text" },
                                        on: {
                                          click: _vm.redirectToRegistration
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Create an account\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-436d7c3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-436d7c3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/signInSection.vue
// module id = null
// module chunks = 